import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';
import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import BorderedBox from '../../BorderedBox';
import FailureModeSection from '../../Sections/FailureModeSection/FailureModeSection';
import ToleranceInstrumentEUComment from '../../Sections/ToleranceInstrumentEUComment/ToleranceInstrumentEUComment';
import SetpointSection from '../../Sections/SetpointSection/SetpointSection';
import TestResultComponent from '../../Sections/TestResultComponent/TestResultComponent';
import SerialNumberSection from '../../Sections/SerialNumberSection/SerialNumberSection';

const P724Form = (props) => (
    <Form
        formName={FormNames.P724}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <SerialNumberSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <FailureModeSection />
        <BorderedBox>
            <AsFoundTestTableSection />
        </BorderedBox>
        <ToleranceInstrumentEUComment />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <BorderedBox>
            <SetpointSection />
        </BorderedBox>
        <TestResultSection />
        <TestResultComponent />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P724Form);
